import navBarSlice from "./slices/navBarSlice";

import modalSlice from "./slices/modalSlice";

const rootReducer = {
  navBar: navBarSlice,

  modal: modalSlice,
};

export default rootReducer;
